import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

export const AutoCleanupToggle = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/test-accounts/auto").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const set = async (enabled) => {
    try { await api.put("/admin/test-accounts/auto", { enabled }); setS((x) => ({ ...x, enabled })); toast.success(enabled ? "Weekly auto-cleanup on" : "Weekly auto-cleanup off"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <label className="mm-soft p-3 mt-4 flex items-center justify-between gap-3 cursor-pointer" data-testid="admin-auto-cleanup">
      <span className="text-sm">
        <b>Weekly auto-cleanup</b>
        <span className="block text-xs text-mm-muted">{s.schedule}: removes accounts matching the rules (never admins or staff) and leftover records.</span>
      </span>
      <Switch checked={s.enabled} onCheckedChange={set} data-testid="admin-auto-cleanup-switch" />
    </label>
  );
};
